// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

Swiper.use([Scrollbar]);

class ScrollSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.swiper');

    this.start = this.dom.el.dataset.start;

    // this.slidesPerView = (this.start === 'start') ? 345 / 294 : 345 / 216;
    // this.slidesPerViewPc = (this.start === 'start') ? 864 / 552 : 864 / 336;
    this.slidesPerView = 345 / 294;
    this.slidesPerViewPc = 864 / 552;

    this.slider = null;
    this.option = {
      loop: false,
      centeredSlides: false,
      slidesPerView: this.slidesPerView,
      // spaceBetween: 16,
      speed: 600,
          
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev'
      // },
    
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true 
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewPc,
        },
      }
    };

    this.init();
  }

  init() {
    this.slider = new Swiper(this.dom.slider, this.option);
    
    if (this.start === 'end') {
      this.slider.slideTo(this.slider.slides.length);
    }
  }
}

export default ScrollSlides